import { render } from "./CoachList.vue?vue&type=template&id=180f651c&scoped=true"
import script from "./CoachList.vue?vue&type=script&lang=js"
export * from "./CoachList.vue?vue&type=script&lang=js"

import "./CoachList.vue?vue&type=style&index=0&id=180f651c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180f651c"]])

export default __exports__